'use strict';

export default typeof FormData !== 'undefined' ? FormData : null;



// WEBPACK FOOTER //
// ../lib/platform/browser/classes/FormData.js